module.exports = __webpack_public_path__ + "static/media/user.cc5d9ef5.svg";